var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "call_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.37 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#call_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.32 21c-2.08 0-4.14-.45-6.17-1.36-2.04-.91-3.88-2.2-5.55-3.87a18.5 18.5 0 0 1-3.86-5.54c-.91-2.04-1.37-4.1-1.37-6.18A1.02 1.02 0 0 1 4.42 3h4.05c.24 0 .44.08.63.24.18.16.29.34.32.56l.65 3.5c.04.27.03.5-.02.67-.05.19-.14.35-.28.48L7.35 10.9c.33.62.73 1.21 1.19 1.79.45.57.96 1.13 1.5 1.66A17.6 17.6 0 0 0 13.48 17l2.35-2.35c.15-.15.35-.26.6-.34.23-.07.47-.1.7-.06l3.45.7c.24.07.43.19.58.36.15.18.22.37.22.59v4.05A1.02 1.02 0 0 1 20.32 21M6.4 9l1.65-1.65L7.62 5H5.4c.08.68.2 1.36.35 2.03.15.66.36 1.32.65 1.97m8.95 8.95a12.4 12.4 0 0 0 4.02 1v-2.2l-2.35-.48z"
  }))));
};
export default SvgCall;